<template>
  <div class="dflexr-jcs marketplace-roller-results" id="marketplace-results">
    <div class="dflexc-jcs input-panel">

      <div class="dflexc-jcs population-list">
        <ul class="pop-list">
          <li class="pop-list-item" :id="item.city"
              @click="(() => city_selected(item.city))"
              v-for="item in mp_pkg.pop_list" :key="item.id" >
            <div class="dflexr-jcsa">
              <div>{{ item.city }}</div>
              <div>{{item.population}}</div>
            </div>

          </li>
        </ul>
      </div>

      <div class="city-search">
        <input type="text" class="inp-city-search" id="cvt-name-input"
               v-model="citySearchVal" ref="cvt_el"
               placeholder="Enter City/Village/Town Name" @keyup="search"/>
      </div>

      <NumPad @generate="(population) => generate(population)" :store="marketStore"
              :display_val="numpad_display_val"/>

    </div>

    <div class="results-container">

      <MarketResultsPanel :pkg="mp_pkg" :show_marketplace_help="showMarketplaceHelp"/>


      <div class="dflexr-jcsb marketplace-footer">
        <div class="dflexr-jcsb marketplace-history-panel">
          <ResultsHistoryControl :cur_rec="meta.cur_rec" :tot_rec="meta.tot_rec"
                              v-on:hist-prev="history_step_one(-1)"
                              v-on:hist-next="history_step_one(1)"
                              v-on:hist-first="history_goto('first')"
                              v-on:hist-last="history_goto('last')"
          />
        </div>

        <div class="dflexr-jcc marketplace-info">
          <span  v-if="mp_pkg.qty > 0">
            <span class="txt-marketplaces-gen">Markets Generated:</span> {{mp_pkg.qty}}
          </span>
        </div>
        <div class="dflexr-jcc marketplace-totalvalue">
          <span class="txt-marketplaces-total" v-if="mp_pkg.total_val > 0">total:</span> {{ mp_pkg.total_val }}s
        </div>
      </div>
    </div>

  </div>
</template>

<style lang="scss">
  @import '@/assets/styles/marketplace-roller-view.scss';

</style>

<style scoped lang="scss">

@import '@/assets/styles/marketplace/sm.scss';
@import '@/assets/styles/marketplace/md.scss';
@import '@/assets/styles/marketplace/lg.scss';
@import '@/assets/styles/marketplace/xl';
</style>

<script setup>
import '../assets/styles/history_control.scss'
import NumPad from '../components/numpad/num_pad.vue'
import MarketResultsPanel from '../components/marketplace/marketplace_results_panel.vue'
import ResultsHistoryControl from "@/components/results_history_control.vue";
import {onMounted, onUpdated, provide, reactive, ref} from "vue";

const mp_pkg = reactive({
  cityName: '',
  population: 0,
  active_mp: 0,
  active_merchant_idx: [0],
  list: [],
  pop_list: [],
  qty: 0,
})

const meta = reactive({
  cur_rec: 0,
  tot_rec: 0
})

const showMarketplaceHelp = ref(true)
const marketStore = window.novasectorapp.marketStore
const citySearchVal = ref('')
const numpad_display_val = ref('0')
const city_not_in_db = ref(false)
const cvt_el = ref()

let pop_list_update = false

provide ('mp_pkg', mp_pkg)

onMounted(() => {
  mp_pkg.pop_list = marketStore.pop_list

})

onUpdated(function () {

})

async function search(event) {
  // const cvt_el = document.getElementById('cvt-name-input')
  const cvt = cvt_el.value.value
  console.log('cvt:', cvt)
  const results = await marketStore.cvt_search(cvt)

  console.log('search results: ', results)
  if(results.city === 'not found') {
    numpad_display_val.value = '0'
    city_not_in_db.value = true
  } else {
    numpad_display_val.value = String(results.population)
    city_not_in_db.value = false
  }
}

function city_selected(sel_city) {
  showMarketplaceHelp.value = false
  for(const item of mp_pkg.pop_list) {
    if( item.city === sel_city ) {
      citySearchVal.value = sel_city
      numpad_display_val.value = item.population
      city_not_in_db.value = false
      mp_pkg.cityName = item.city
      mp_pkg.population = item.population
    }
  }
}


async function generate(population) {
  if(population === '0')
    return

  showMarketplaceHelp.value = false

  let num_markets = 2
  let mp_results
  console.log('generating markets: population:', population)
  // check if city not in database
  if(city_not_in_db.value) {
    const pop = parseInt(population)
    // update database
    if(pop > 200) {
      const city = citySearchVal.value

      console.log('Adding city to db: ', city, ' population: ', pop )

      const x_res = await marketStore.add_population(city, pop)
      pop_list_update = true
      const xData = await x_res.json()
      console.log('x_res: ', xData)
      if(xData.status === 'success') {
        marketStore.pop_list.push(xData.data)
      }

      console.log('xData:', xData )
    }

  }
  await gen_market(population)
}

async function gen_market(population) {
  mp_pkg.population = population // this is also set in
  mp_pkg.list = await marketStore.roll(population)
  const numMP = mp_pkg.list.length
  const xArr = []
  for(let i = 0; i < numMP; i++) {
    xArr.push(0)
  }
  mp_pkg.active_merchant_idx = xArr
}


function update_market_results () {
  Object.assign(jpkg, marketStore.currentSet)
  meta.cur_rec = marketStore.cur_rec
  meta.tot_rec = marketStore.tot_rec
}


function history_step_one(step) {
  marketStore.history_step(step)
  update_market_results()
}


function history_goto(val) {
  marketStore.history_goto(val)
  update_market_results()
}


</script>
